import { Box, Card, CircularProgress, Grid2, Slider } from "@mui/material";
import PlanCardStyle from "../PlanCard/PlanCardStyle.module.scss";
import PlanFeatures from "../PlanFeatures/PlanFeatures";
import { useEffect, useRef, useState } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { ReactComponent as Launchpad } from "../../../../AdminAssets/svg/LaunchPad.svg";
import { ReactComponent as GrowthGear } from "../../../../AdminAssets/svg/GrowthGear.svg";
import { ReactComponent as Momentum } from "../../../../AdminAssets/svg/Momentum.svg";
import { ReactComponent as Booster } from "../../../../AdminAssets/svg/Booster.svg";
import { ReactComponent as ToTheMoon } from "../../../../AdminAssets/svg/ToTheMoon.svg";
import { ReactComponent as SiteIcon } from "../../../../AdminAssets/svg/siteIcon.svg";
import { ReactComponent as StorageIcon } from "../../../../AdminAssets/svg/cloud_upload.svg";
import { ReactComponent as VisitsIcon } from "../../../../AdminAssets/svg/visits.svg";
import { ReactComponent as BackupIcon } from "../../../../AdminAssets/svg/backup.svg";
import { ReactComponent as BandwidthIcon } from "../../../../AdminAssets/svg/bandwidth.svg";
import { ReactComponent as IndPaymentIcon } from "../../../../AdminAssets/svg/indPayment.svg";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  convertToYearlyPrice,
  formatIndianCurrency,
  useEmailId,
} from "../../../../../../Utils/utils";
import ModalPopup from "../../../../../../GlobalComponents/Popup/ModalPopup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../../../Utils/cashfree";
import ZohoChatComponent from "../../../../AdminComponents/ZohoChatComponent/ZohoChatComponent";
import BasePlanBillingSummary from "../BasePlanBillingSummary/BasePlanBillingSummary";
import axios from "axios";
import { getRoleInOrg } from "../../../../../../Utils/organizations";

const PlanCard = (props) => {
  const {
    planType,
    subheader,
    allPlans,
    billingType,
    extractPricing,
    handleUpdateClick,
    isAgency,
    downgradePopup,
    noUpgradePopupFunc,
    upgradePopupFunc,
    upgradeFailPopupFunc,
    singleSitePopupFunc,
    waitPlanPopupFunc,
    isSingleSite,
    selectedLicenseType,
    basePlan,
    specificPlan,
    isProcessingCashfree,
    noPermissionPopupFunc,
    selectedOrg,
    userDetails,
    country,
    selectedGrid,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [sliderValue, setSliderValue] = useState(20);
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);
  const [isIndPayment, setIsIndPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isloadingPopup, setIsLoadingPopup] = useState(false);
  const [liveChatTrigger, setLiveChatTrigger] = useState(false);
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const [isData, setIsData] = useState(null);
  const [showInput, setShowInput] = useState(false);
  const prevSliderValue = useRef(sliderValue);
  const params = useParams();
  let orgId = parseInt(params.orgId);

  const emailId = useEmailId();

  const isProcessing = isProcessingCashfree?.paymentProcess === true;

  const marks =
    selectedGrid === "Dedicated Hosting"
      ? [{ value: 20 }, { value: 45 }, { value: 70 }, { value: 95 }]
      : [
          { value: 20 },
          { value: 45 },
          { value: 70 },
          { value: 95 },
          { value: 120 },
        ];

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_SEPCIFIC_PLAN,
      data: { orgId: orgId },
    });
  }, [orgId]);

  useEffect(() => {
    prevSliderValue.current = sliderValue;
  }, []);

  // Preselect the slider value based on selectedLicenseType
  useEffect(() => {
    if (selectedLicenseType) {
      const preselectedPlan = allPlans.find(
        (plan) => plan.licenseType === selectedLicenseType,
      );

      if (preselectedPlan) {
        const index = allPlans.indexOf(preselectedPlan);
        const sliderValue = 20 + index * 25;
        setSliderValue(sliderValue);
        prevSliderValue.current = sliderValue;
      }
    }
  }, [selectedLicenseType]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isRenew = searchParams.get("renew") === "true";

    if (isRenew && selectedLicenseType) {
      const currentPlanIndex = allPlans.findIndex(
        (plan) => plan.licenseType === selectedLicenseType,
      );

      if (currentPlanIndex !== -1) {
        const sliderValueForCurrentPlan = 20 + currentPlanIndex * 25;
        setSliderValue(sliderValueForCurrentPlan);
        prevSliderValue.current = sliderValueForCurrentPlan;
        handleClick();
        setIsPaneOpen(true);
      }
    }
  }, [location.search, selectedLicenseType, allPlans]);

  const currentPlanIndex = Math.floor((sliderValue - 10) / 25);
  const currentPlan = allPlans?.[currentPlanIndex] || {};

  const matchingBillingData =
    extractPricing?.find(
      (item) =>
        item?.billingType === billingType &&
        item?.licenseType === currentPlan?.licenseType,
    ) || {};

  const monthlyBillingData =
    extractPricing?.find(
      (item) =>
        item?.billingType === "Monthly" &&
        item?.licenseType === currentPlan?.licenseType,
    ) || {};

  const matchFeatureData =
    extractPricing?.find(
      (item) =>
        item?.billingType === billingType &&
        item?.licenseType === currentPlan?.licenseType,
    ) || {};
  const salePriceInr =
    billingType === "Monthly"
      ? monthlyBillingData?.salePriceInr
      : convertToYearlyPrice(monthlyBillingData?.salePriceInr);
  const salePriceUS =
    billingType === "Monthly"
      ? monthlyBillingData?.originalPrice
      : convertToYearlyPrice(monthlyBillingData?.originalPrice);

  const billingSalePrice = country === "USA" ? salePriceUS : salePriceInr;
  const licenseTypeToIcon = {
    LaunchPad: <Launchpad />,
    GrowthGear: <GrowthGear />,
    Momentum: <Momentum />,
    Booster: <Booster />,
    ToTheMoon: <ToTheMoon />,
  };

  const normalizedLicenseType = currentPlan?.licenseType?.replace(/\s+/g, "");
  const planIcon = isAgency ? (
    <Booster />
  ) : (
    licenseTypeToIcon[normalizedLicenseType]
  );

  const isCurrentPlan =
    selectedLicenseType === currentPlan?.licenseType &&
    basePlan?.billingType === billingType;

  const handleSliderChange = (event, newValue) => {
    // if (isCurrentPlan && newValue < prevSliderValue.current) {
    //   downgradePopup();
    // }

    setSliderValue(newValue);
    setTimeout(() => {
      prevSliderValue.current = newValue;
    }, 0);
  };

  const toTheMoon = sliderValue === 120 ? true : false;
  const displayText = isAgency ? "Starting" : currentPlan?.licenseType;

  const handleClick = async () => {
    try {
      setIsCouponLoading(true);
      const response = await axios.post(
        // Billing is always an authenticated user, so use the authenticated endpoint
        // which requires the token and always runs the already-redeemed coupon check.
        `${process.env.REACT_APP_BACK_END_API_BASE_URL}/plans/plansPrice/user`,
        {
          stripe: country === "USA",
          coupon: coupon ? coupon : "",
          priceId: matchingBillingData?.stripePriceId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        },
      );
      if (response) {
        setIsCouponLoading(false);
        setIsData(response?.data);
      }
    } catch (e) {
      setIsCouponLoading(false);
    }
  };

  const handleUpdateNowClick = async () => {
    if (
      getRoleInOrg(emailId, selectedOrg) === "User" ||
      getRoleInOrg(emailId, selectedOrg) === "Admin"
    ) {
      noPermissionPopupFunc();
      return;
    }
    const currentIndex = allPlans.findIndex(
      (plan) => plan.licenseType === selectedLicenseType,
    );
    const newIndex = allPlans.findIndex(
      (plan) => plan.licenseType === currentPlan.licenseType,
    );

    if (newIndex < currentIndex) {
      downgradePopup();
      return;
    }

    setIsLoading(true);
    try {
      setIsLoading(false);
      setIsPaneOpen(true);
      handleClick();
      await handleUpdateClick(currentPlan.licenseType);
    } finally {
      setIsLoading(false);
    }
  };

  const isPlanExpiredOrExpiring =
    basePlan?.daysAfterExpiry <= 0 && basePlan?.daysAfterExpiry !== null;

  // Check if current plan and selected plan have different site types (MS to SS or SS to MS)
  const isSiteTypeSwitch =
    (basePlan?.isSingleSite === false && isSingleSite === true) ||
    (basePlan?.isSingleSite === true && isSingleSite === false);

  const getClickHandler = () => {
    // "Renew Now"
    if (
      isCurrentPlan &&
      (basePlan?.daysAfterExpiry > 0 || isPlanExpiredOrExpiring)
    ) {
      return handleUpdateNowClick;
    }
    // "Current Plan"
    if (isCurrentPlan) {
      return null;
    }
    // "Let's Connect" for site type switches (MS to SS or SS to MS)
    if (isSiteTypeSwitch) {
      return triggerLiveChat;
    }
    // "Let's Connect"
    if (isAgency || toTheMoon) {
      return () =>
        window.open(
          "https://roconpaas.com/wordpress-hosting-for-agencies/#custom-plan",
          "_blank",
        );
    }
    // For "Upgrade Now" / "Buy Now"
    return handleUpdateNowClick;
  };

  const getButtonLabel = () => {
    if (
      isCurrentPlan &&
      (basePlan?.daysAfterExpiry > 0 || isPlanExpiredOrExpiring)
    )
      return "Renew Now";
    if (isCurrentPlan) return "Current Plan";
    if (isSiteTypeSwitch) return "Let's Connect";
    if (isAgency || toTheMoon) return "Let's Connect";
    return isLoading ? (
      <CircularProgress size={20} color="inherit" />
    ) : specificPlan?.length > 0 ? (
      "Upgrade Now"
    ) : (
      "Buy Now"
    );
  };

  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_GET_STRIPE_PUBLISHABLE_KEY,
      meta: {
        onSuccess: (data) => {
          const stripePromise = loadStripe(data);
          setStripePromise(stripePromise);
        },
        onError: () => {},
      },
    });
  }, []);

  const flushStateVariables = () => {
    setIsPaneOpen(false);
    setShowInput(false);
    setCoupon(null);
    setIsData(null);

    // Remove renew query parameter from URL
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("renew")) {
      searchParams.delete("renew");
      const newSearch = searchParams.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
      navigate(newUrl, { replace: true });
    }
  };

  const handleIndPayment = () => {
    setIsLoadingPopup(true);

    getStore().dispatch({
      type: Actions.GET_CASHFREE_CREATE_SUBSCRIPTION,
      data: {
        coupon: coupon,
        orgId: orgId ? orgId : -1,
        priceId: matchingBillingData?.stripePriceId,
      },
      meta: {
        onSuccess: (data) => {
          setIsLoadingPopup(false);
          if (isData?.totalAmount === 0) {
            navigate(`/account/${orgId ? orgId : -1}/dashboard`);
            return;
          }
          const cleanedData = data.replace(/\\/g, "");
          cashfreeSubscriptionSessionIdDecrypt(cleanedData);
          // navigate(`/account/${orgId ? orgId : -1}/dashboard`);
        },
        onError: () => {
          setIsLoadingPopup(false);
        },
      },
    });
  };

  const triggerLiveChat = () => {
    setLiveChatTrigger(true);

    setTimeout(() => {
      document.getElementById("zsiq_float").click();
    }, 3000);
  };

  return (
    <Grid2>
      <Card className={PlanCardStyle.cardContainer}>
        {isCurrentPlan && (
          <Grid2
            className={`${PlanCardStyle.currentPlan} ${
              basePlan?.daysAfterExpiry > 0 || isPlanExpiredOrExpiring
                ? PlanCardStyle.expired
                : ""
            }`}
          >
            {basePlan?.daysAfterExpiry > 0 || isPlanExpiredOrExpiring
              ? "Expired"
              : "Current Plan"}
          </Grid2>
        )}
        <Grid2 className={PlanCardStyle.headerBlock}>
          <Grid2 className={PlanCardStyle.header}>{planType}</Grid2>
          <Grid2 className={PlanCardStyle.subheader}>{subheader}</Grid2>
        </Grid2>

        <Grid2 className={PlanCardStyle.descpBlock}>
          <Grid2 className={PlanCardStyle.descp}>
            <Grid2 className={PlanCardStyle.planLabel}>{displayText}</Grid2>
            <Grid2 className={PlanCardStyle.discountBlock}>
              {!toTheMoon && billingType === "Yearly" && (
                <>
                  <Grid2 className={PlanCardStyle.salePrice}>
                    {!isAgency && (
                      <span>
                        {country === "India"
                          ? `₹${(salePriceInr / 12).toFixed(2)}`
                          : `$${(salePriceUS / 12).toFixed(2)}`}{" "}
                        /mon
                      </span>
                    )}
                  </Grid2>
                  {!isAgency && (
                    <Grid2 className={PlanCardStyle.discountPercent}>
                      {selectedGrid === "Kubernetes Hosting"
                        ? matchingBillingData?.licenseType === "LaunchPad"
                          ? "Save 85%"
                          : "Save 15%"
                        : ""}
                      {selectedGrid === "Dedicated Hosting"
                        ? matchingBillingData?.licenseType === "LaunchPad"
                          ? planType === "Solo-Site Plans"
                            ? "Save 70%"
                            : "Save 75%"
                          : "Save 15%"
                        : ""}
                    </Grid2>
                  )}
                </>
              )}
            </Grid2>

            {!toTheMoon && (
              <Grid2>
                <Grid2 className={PlanCardStyle.originalPriceBlock}>
                  {isAgency ? (
                    <Grid2 className={PlanCardStyle.customPrice}>
                      Custom pricing
                    </Grid2>
                  ) : (
                    <>
                      <Grid2 className={PlanCardStyle.originalPrice}>
                        {billingType === "Yearly"
                          ? country === "India"
                            ? `₹${formatIndianCurrency(
                                (
                                  matchingBillingData?.orginalPrice_INR / 12
                                ).toFixed(2),
                              )}`
                            : `$${formatIndianCurrency(
                                (
                                  matchingBillingData?.originalPrice / 12
                                ).toFixed(2),
                              )}`
                          : country === "India"
                            ? `₹${formatIndianCurrency(
                                matchingBillingData?.orginalPrice_INR,
                              )}`
                            : `$${formatIndianCurrency(
                                matchingBillingData?.originalPrice,
                              )}`}
                      </Grid2>
                      <Grid2 className={PlanCardStyle.monpadding}>/mon</Grid2>
                    </>
                  )}
                </Grid2>
              </Grid2>
            )}
          </Grid2>

          <Grid2 className={PlanCardStyle.planIcon}>{planIcon}</Grid2>
        </Grid2>
        {toTheMoon ? (
          <Grid2 className={PlanCardStyle.benifits}>
            Contact Sales for Exclusive benefits
          </Grid2>
        ) : (
          ""
        )}

        {!isAgency ? (
          <>
            <Box sx={{ width: 300 }}>
              <Slider
                aria-label="Plan Slider"
                value={sliderValue}
                step={null}
                marks={marks}
                min={10}
                max={selectedGrid === "Dedicated Hosting" ? 105 : 130}
                valueLabelDisplay="off"
                onChange={handleSliderChange}
                sx={{
                  color: "#1976d2",
                  height: 6,
                  "& .MuiSlider-thumb": {
                    height: 20,
                    width: 20,
                    backgroundColor: "white",
                    border: "5px solid #1976d2",
                    borderRadius: "50%",
                    "&:hover, &.Mui-focusVisible": {
                      boxShadow: "inherit",
                    },
                    "&.Mui-active": {
                      boxShadow: "inherit",
                    },
                  },
                  "& .MuiSlider-track": {
                    height: 6,
                    borderRadius: 4,
                  },
                  "& .MuiSlider-rail": {
                    height: 6,
                    borderRadius: 4,
                    backgroundColor:
                      userDetails?.theme === "dark" ? "#fff" : "#000",
                  },
                  "& .MuiSlider-mark": {
                    height: 8,
                    width: 8,
                    backgroundColor: "white",
                    borderRadius: "50%",
                  },
                }}
              />
            </Box>
          </>
        ) : (
          <Grid2 className={PlanCardStyle.agencyheight}>
            <Grid2 className={PlanCardStyle.agency}>
              Agency exclusive benefits
            </Grid2>
          </Grid2>
        )}

        <Grid2 className={PlanCardStyle.featureBlock}>
          <PlanFeatures
            icon={<SiteIcon />}
            featureName="Sites"
            featureValue={matchFeatureData?.numSitesLimit || "Unlimited"}
          />
          <PlanFeatures
            icon={<StorageIcon />}
            featureName="Storage"
            featureValue={matchFeatureData?.storageLimit || "Unlimited"}
          />
          <PlanFeatures
            icon={<VisitsIcon />}
            featureName="Visits"
            featureValue={matchFeatureData?.visitsLimit || "Unlimited"}
          />
          <PlanFeatures
            icon={<BandwidthIcon />}
            featureName="Bandwidth"
            featureValue={matchFeatureData?.bandwidthLimit || "Unlimited"}
          />
          <PlanFeatures
            icon={<BackupIcon />}
            featureName="Backup retention"
            featureValue={matchFeatureData?.backupLimit || "Unlimited"}
          />
        </Grid2>

        <Grid2
          className={`${PlanCardStyle.planButton} ${
            isCurrentPlan ? PlanCardStyle.isCurrentPlan : ""
          } ${
            isCurrentPlan &&
            (basePlan?.daysAfterExpiry > 0 || isPlanExpiredOrExpiring)
              ? PlanCardStyle.renewPlan
              : ""
          }`}
          onClick={getClickHandler()}
          style={{
            cursor: isCurrentPlan ? "default" : "pointer",
            opacity: isCurrentPlan ? 0.7 : 1,
          }}
        >
          {getButtonLabel()}
        </Grid2>
      </Card>

      {isPaneOpen && (
        <Elements stripe={stripePromise}>
          <BasePlanBillingSummary
            isPaneOpen={isPaneOpen}
            currentPlan={currentPlan}
            billingType={billingType}
            matchingBillingData={matchingBillingData}
            country={country}
            numSites={matchFeatureData?.numSitesLimit}
            isAddon={false}
            downgradePopup={downgradePopup}
            noUpgradePopup={noUpgradePopupFunc}
            upgradePopup={upgradePopupFunc}
            upgradeFailPopup={upgradeFailPopupFunc}
            singleSitePopup={singleSitePopupFunc}
            isSingleSite={isSingleSite}
            billingSalePrice={billingSalePrice}
            setIsPaneOpen={setIsPaneOpen}
            waitPlanPopup={waitPlanPopupFunc}
            formatIndianCurrency={formatIndianCurrency}
            indPayment={() => setIsIndPayment(true)}
            flushStateVariables={flushStateVariables}
            setIsIndPayment={setIsIndPayment}
            specificPlan={specificPlan}
            orgId={orgId}
            isLoading={isLoadingStripe}
            setIsLoading={setIsLoadingStripe}
            navigate={navigate}
            coupon={coupon}
            setCoupon={setCoupon}
            isCouponLoading={isCouponLoading}
            handleClick={handleClick}
            isData={isData}
            setIsData={setIsData}
            showInput={showInput}
            setShowInput={setShowInput}
            isProcessingCashfree={isProcessingCashfree}
            handleIndPayment={handleIndPayment}
            isProcessing={isProcessing}
          />
        </Elements>
      )}

      {!isProcessing && (
        <>
          <ModalPopup
            trigger={isIndPayment}
            header={"Note"}
            nextpopup={"Pay Now"}
            nextOnClick={() => {
              handleIndPayment();
            }}
            backPopup={"Cancel"}
            backOnClick={() => {
              setIsIndPayment(false);
            }}
            customWidth="750px"
            loading={isloadingPopup}
          >
            <Grid2
              className={`${PlanCardStyle.imgCenter} ${PlanCardStyle.animatedOvalContainer}`}
            >
              <IndPaymentIcon />
            </Grid2>
            <Grid2 className={PlanCardStyle.decsGap}>
              <Grid2 className={PlanCardStyle.PointRight}>👉</Grid2>
              <Grid2 className={PlanCardStyle.desc}>
                {billingType === "Yearly" && (
                  <>
                    {isData?.couponDiscountResponse?.amountOff !== null && (
                      <span>
                        Your discounted monthly price of{" "}
                        <span className={PlanCardStyle.amount}>
                          ₹
                          {formatIndianCurrency(
                            isData?.couponDiscountResponse?.amountOff
                              ? isData?.couponDiscountResponse?.amountOff +
                                  isData?.platformDisc
                              : isData?.platformDisc,
                          )}
                        </span>{" "}
                        has been successfully applied.{" "}
                      </span>
                    )}
                  </>
                )}
                Please note, the amount shown on the next page reflects the
                maximum monthly price that will be charged after your discount
                period ends.
              </Grid2>
            </Grid2>
            <Grid2 className={PlanCardStyle.decsGap}>
              <Grid2 className={PlanCardStyle.PointRight}>👉</Grid2>
              <Grid2 className={PlanCardStyle.desc}>
                <strong>
                  Rest assured, you are not currently paying the max amount
                  shown on the next page.
                </strong>{" "}
                If you have any questions or encounter any issues, please don’t
                hesitate to reach out to{" "}
                <span
                  className={PlanCardStyle.clickText}
                  onClick={triggerLiveChat}
                >
                  Team Rocon
                </span>{" "}
                — we’re always here to assist you!
              </Grid2>
            </Grid2>
          </ModalPopup>
        </>
      )}
      {liveChatTrigger && <ZohoChatComponent />}
    </Grid2>
  );
};

export default PlanCard;
